<template>
  <div id="filter-content" class="filter-content suck_down">
    <div class="load-data-wrap col full-height">
      <div class="fit">
        <div class="v-scroll-area fit vrow relative-position">
          <div class="content-wrap fit">
            <div class="scroll-header absolute">
              <div class="c-match-list-header yb-flex-between" load_type="filter">
                <div class="col-left vrow items-center">
                  <div class="btn-wrap match-btn yb-flex-center cursor-pointer active" style="display: none;">
                    {{ sportTableLang.table['SPORT_TABLE.LBL_SELECT_ALL'] }}
                  </div>
                  <div title="sportTableLang.table['SPORT_TABLE.LBL_MY_FAVOURITE']" class="btn-wrap collect-btn yb-flex-center cursor-pointer" style="display: none;">
                    <i aria-hidden="true" role="presentation" class="q-icon icon-star c-icon set-color" style="color: rgb(171, 186, 200); font-size: 14px;">
                    </i>
                    <span class="number"></span>
                  </div>
                  <div class="list-title vrow items-center">
                    <div class="title-text yb-font-bold ellipsis">
                      <!-- <template v-if="!showFavEvents"> -->
                      <template v-if="((selectedMarket == market.inPlayMarket.key) || open_RBMarket)">
                        {{ sportTableLang.table['SPORT_TABLE.HEADER_IN_PLAY_MARKET'] }}
                      </template>
                      <template v-else-if="selectedMarket == market.tdyMarket.key">
                        {{ sportTableLang.table['SPORT_TABLE.HEADER_TODAY_MARKET'] }}
                      </template>
                      <template v-else>
                        {{ sportTableLang.table['SPORT_TABLE.HEADER_EARLY_MARKET'] }}
                      </template>

                      <template v-if="(subTitle == '' && selectedBettype.sprtTitleLang) && !open_RBMarket">
                        ({{ selectedBettype.sprtTitleLang }})
                      </template>
                      <!-- </template> -->
                    </div>
                  </div>
                </div>
                <div class="col-right yb-flex-center">
                  <div class="search-wrap-league">
                    <i aria-hidden="true" role="presentation"
                      class="search-icon q-icon icon-search c-icon set-color"
                      style="color: rgb(171, 186, 200); font-size: 12px;"> </i>
                    <input :placeholder="sportTableLang.table['SPORT_TABLE.LBL_SELECT_SEARCH']" v-on:keyup="searchLg" type="search" class="search-input search-league">
                  </div>
                  <div class="select-btn leagues-btn yb-flex-center cursor-pointer filter-handle yb-hover-bg active l123" @click="toggleLeague()">
                    {{ sportTableLang.table['SPORT_TABLE.SUBHEADER_SELECT_LEAGUE'] }}
                    <span class="status yb-font-bold filter_full_all">
                      <template v-if="selectedLeague.length>0">
                        {{ selectedLeague.length }}
                      </template>
                      <template v-else>
                        {{ sportTableLang.table['SPORT_TABLE.LBL_SELECT_ALL']  }}
                      </template>
                    </span>
                    <i size="14px" class="icon-arrow q-icon c-icon"></i>
                  </div>
                  <div show_type="sort" class="flex list-sort select-btn yb-hover-bg" style="display: none;">
                    <!-- <div class="active list-sort-item">热门</div> -->
                    <div class="yb-hover-bg list-sort-item">
                      {{ sportTableLang.table['SPORT_TABLE.SUBHEADER_SORTBY_TIME'] }}
                    </div>
                  </div>
                  <div class="select-btn refresh-btn yb-flex-center yb-hover-bg" style="display: none;"></div>
                </div>
              </div>
            </div>
            <div class="fit v-scrollarea q-scrollarea">
              <div id="leagueSelection" class="q-scrollarea__container scroll relative-position fit" >
                <div class="scroll-inner-wrap fit" style="overflow-y:auto !important">
                <div class="q-scrollarea__content absolute">
                  <div class="middle-content" style="padding-top: 36px; padding-bottom: 0px;">
                    <div class="scroll-inner-wrap fit">
                      <div class="filter-list">

                        <template v-if="open_RBMarket && selectedSport.sprtId=='G98'">
                          <template v-for="(sportdataObj, sportObjKey) in leagueList">
                            <div class="filter-title">
                              <div class="yb-flex-center cursor-pointer">
                                <!-- <div class="check-wrap relative-position"></div> -->
                                <label>
                                  <input v-bind:id="sportObjKey" type="checkbox" v-model="selectedLeagueSport[sportObjKey].checked" @change="selCheckLeague(sportObjKey)" v-bind:value="selectedLeagueSport[sportObjKey].checked">
                                  <div class="check-wrap relative-position" :class="{'active':selectedLeagueSport[sportObjKey].checked}"></div>
                                </label>
                                <div class="country-name">{{ getSportLang(sportObjKey) }}</div>
                              </div>
                            </div>
                            
                            <div class="filter-item-content allSport">
                              <template v-for="(dataObj, ObjKey) in sportdataObj" v-if="ObjKey!=='checked'">
                                <template v-for="data in dataObj">
                                  <div class="filter-item cursor-pointer" v-show="showLeague(data.id, selectedOnly)"
                                    v-if="data.id != null && ((searchLeague && data.show) || !searchLeague)">
                                    <label>
                                      <input v-bind:id="data.id" type="checkbox" v-model="selectedLeague" @change="changeSelectedLeague2(sportObjKey, data.id)" v-bind:value="data.id">
                                      <div class="check-wrap relative-position" :class="{'active':selectedLeague.includes(data.id)}"></div>
                                    </label>
                                    <div class="filter-item-title ellipsis" :title="data.lgecapt"
                                    @click="checkLeague(sportObjKey, data.id)" >
                                      <template v-if="selectedBettype.betTypId!='6'"><span v-html="data.lgecapt"></span></template>
                                      <template v-else>{{ data.capt }}</template>
                                    </div>
                                    <div class="filter-item-num">{{ data.c }}</div>
                                  </div>
                                </template>
                              </template>
                            </div>
                          </template>
                        </template>
                        <template v-else-if="open_RBMarket">
                          <div class="filter-item-content singleSport">
                            <template v-for="league in leagueList">
                              <template v-for="data in league">
                                <div class="filter-item cursor-pointer" 
                                  v-show="showLeague(data.id, selectedOnly)"
                                  v-if="data.id != null && ((searchLeague && data.show) || !searchLeague)">
                                  <label>
                                    <input v-bind:id="data.id" type="checkbox" v-model="selectedLeague" @change="changeSelectedLeague" v-bind:value="data.id">
                                    <div class="check-wrap relative-position" :class="{'active':selectedLeague.includes(data.id)}"></div>
                                  </label>
                                  <div class="filter-item-title ellipsis" :title="data.lgecapt"
                                  @click="checkLeague(null, data.id)">
                                    <template v-if="selectedBettype.betTypId!='6'"><span v-html="data.lgecapt"></span></template>
                                    <template v-else>{{ data.capt }}</template>
                                  </div>
                                  <div class="filter-item-num">{{ data.c }}</div>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <template v-for="(stateData, stateKey) in selectedLeagueState">
                            <div class="filter-title">
                              <div class="yb-flex-center cursor-pointer">
                                <label>
                                  <input v-bind:id="stateKey" type="checkbox" v-model="stateData.checked" @change="selState(stateKey)" v-bind:value="stateData.checked">
                                  <div class="check-wrap relative-position" :class="{'active':stateData.checked}"></div>
                                </label>
                                <div class="country-name">{{ sportTableLang.table['SPORT_TABLE.STATE_'+stateData.state] }}</div>
                              </div>
                            </div>
                            
                            <div class="filter-item-content allSport">
                              <template v-for="(lgedt, lgeid) in stateData.leagues">
                                <div class="filter-item cursor-pointer" 
                                  v-show="showLeague(lgedt.id, selectedOnly)"
                                  v-if="lgedt.id != null">
                                  <label>
                                    <input v-bind:id="lgedt.id" type="checkbox" v-model="selectedLeague" @change="changeSelectedLeague3(stateKey)" v-bind:value="lgedt.id">
                                    <div class="check-wrap relative-position" :class="{'active':selectedLeague.includes(lgedt.id)}"></div>
                                  </label>
                                  <div class="filter-item-title ellipsis" :title="lgedt.lgecapt"
                                  @click="checkLeague(stateKey, lgedt.id)">
                                    <template v-if="selectedBettype.betTypId!='6'"><span v-html="lgedt.lgecapt"></span></template>
                                    <template v-else>{{ lgedt.capt }}</template>
                                  </div>
                                  <div class="filter-item-num">{{ lgedt.c }}</div>
                                </div>
                              </template>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <!-- <div aria-hidden="true" class="q-scrollarea__bar q-scrollarea__bar--v absolute-right"></div>
              <div aria-hidden="true"
                class="q-scrollarea__bar q-scrollarea__bar--h absolute-bottom q-scrollarea__bar--invisible"></div>
              <div aria-hidden="true" class="q-scrollarea__thumb q-scrollarea__thumb--v absolute-right"></div>
              <div aria-hidden="true"
                class="q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom q-scrollarea__thumb--invisible"></div> -->
            </div>
            <div class="scroll-footer" style="bottom: 0px;"></div>
          </div>

        </div>
        <div class="botton-box suck_down">
          <div class="cursor-pointer width140 border1" @click="changeSelectAll()">
            <div class="check-wrap relative-position" :class="{'active':selectAll}"></div>
            <div class="country-name">{{ sportTableLang.table['SPORT_TABLE.LBL_SEL_ALL_MATCH'] }}</div>
            <div class="all-count">{{ totalLeagues }}</div>
          </div>
          <div class="col yb-flex-center">
            <div class="mbtn btn1" :class="{'dis':Object.keys(selectedLeague).length==0}" @click="filterLeague()">{{ sportTableLang.table['SPORT_TABLE.BTN_SUBMIT'] }}
            </div>
            <div class="mbtn btn2" v-on:click="toggleLeague()">{{ sportTableLang.table['SPORT_TABLE.LBL_CANCEL'] }}
            </div>
          </div>
          <div class="width140 border1"></div>
        </div>
      </div>
      <div class="column yb-flex-center empty"></div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import EventBus from '../../../events/event-bus'

export default {
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sportList',
      'sportIdArr',
      'cookieLeague',
      'selectedBettype',
      'selectedMarket',
      'selectedSport',
      'market',
      'open_RBMarket',
      'bool_leagueToggle',
      'sortedEventList',
      'arr_leagueList',
    ]),
    // leagueList: function () {
    //   if(this.$store.getters.open_RBMarket && this.$store.getters.selectedSport.sprtId=='G98'){
    //     //group league by sports for all sports (G98)
    //     var list = this.groupLGEBySports()
    //     var isSportAll = true
    //   } else { //normal
    //     var list = _.cloneDeep(this.$store.getters.arr_leagueList)
    //     var isSportAll = false
    //   }
    //   var grouped = this.createGroupedArray(list, 3, isSportAll)
      
    //   // var grouped = list
    //   return grouped
    // },
    totalLeagues: {
      get() {
        return this.$store.getters.totalLeagues
      },
      set(value) {
        this.$store.commit('TOTALLEAGUES', value)
      }
    },
    searchFil_totalLeagues: {
      get() {
        return this.$store.getters.searchFil_totalLeagues
      },
      set(value) {
        this.$store.commit('SEARCHFIL_TOTALLEAGUES', value)
      }
    },
  },
  watch: {
    'selectAll': {
      handler(val, oldVal) {
        this.$store.commit('SELECT_ALL_LEAGUE', val)
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      selectedLeague: [],
      selectedLeagueSport: {},
      selectAll: false,
      showHide: true,
      clearTxt: false,
      searchText: '',
      searchLeague: false,
      selectedOnly: false,
      subTitle: "",
      leagueList: {},
      selectedLeagueState: [],
    }
  },
  methods: {
    selCheckLeague(key){
      var vue = this
      var selLeaguesId = this.selectedLeague
      var chked = this.selectedLeagueSport[key].checked
      $.each(vue.leagueList[key], function(sid, sdata){
        $.each(sdata, function(id, coldata){
          if(!selLeaguesId.includes(coldata.id) && chked){
            selLeaguesId.push(coldata.id)
          }else if(!chked){
            var keyx = _.findIndex(selLeaguesId, (e) => {
                  return e == coldata.id;
              }, 0);
            selLeaguesId.splice(keyx,1)
          }
        });
      });
    },
    groupLGEBySports(){
      var VUE = this
      var sprtID = ''
      var arrangedArray = {}
      var lgelist = _.cloneDeep(this.$store.getters.arr_leagueList)
      _.forEach(lgelist, (data) => {
        sprtID = (!_.isUndefined(VUE.sportIdArr[data.sptid])) && VUE.sportIdArr[data.sptid]

        if(_.isUndefined(arrangedArray[sprtID])){
          arrangedArray[sprtID] = []
          arrangedArray[sprtID].push(data)
        } else {
          arrangedArray[sprtID].push(data)
        }
        this.selectedLeagueSport[sprtID] = {'checked': false}
      });
      return arrangedArray
    },
    getSportLang(sportID){
      var vue = this
      var capt = ''
      _.forEach(vue.sportList, function (sportdata, key) {
        if(sportID == sportdata.sprtId){
          capt = sportdata.sprtLang.replace("<br/>", "")
        }
      })
      
      return capt
    },
    showtitle(data) {
      if (data.lgecapt) {
        return data.lgecapt;
      } else if (data.capt) {
        return data.capt;
      }
      return '';
    },
    clearSearch() {
      $('.search-league').val('')
      this.clearTxt = false;
    },
    changeSelected() {
      //this.selectedOnly = this.selectedOnly ? false : true;
    },
    showLeague($lgId, selectedOnly) {
      if (selectedOnly == false) {
        return true;
      } else if (this.selectedLeague.includes($lgId)) {
        return true;
      }

    },
    searchLg() {
      const searchTxt = $('.search-league').val()
      this.clearTxt = (searchTxt == '') ? false : true;
      var count = 0
      if (this.clearTxt) {
        this.searchLeague = true
        this.searchText = searchTxt;

        if(this.$store.getters.open_RBMarket && this.$store.getters.selectedSport.sprtId=='G98'){
          // this.leagueList.map(function(sprtArr) {
          //   sprtArr.map(function(subArr) {
          $.each(this.leagueList, function(sid, sdata){
            sdata.map(function(subArr) {
              return subArr.map(function(obj) {
                var lgCapt = obj.lgecapt
                obj.show = (lgCapt && lgCapt.toUpperCase().includes(searchTxt.toUpperCase()))  ? true : false
                // obj.show = (obj.lgecapt && obj.lgecapt==searchTxt)  ? true : false
                if(obj.show){
                  count++;
                }
                return obj;
              })
            }) 
          })
        } else {
          this.leagueList.map(function(subArr) {
            return subArr.map(function(obj) {
              var lgCapt = obj.lgecapt
              obj.show = (lgCapt && lgCapt.toUpperCase().includes(searchTxt.toUpperCase()))  ? true : false
              // obj.show = (obj.lgecapt && obj.lgecapt==searchTxt)  ? true : false
              if(obj.show){
                count++;
              }
              return obj;
            })
          })
        }
        if(!this.$store.getters.open_RBMarket) {
          this.setStateList(this.leagueList, false)
        }
        
        this.$store.commit('TOTALLEAGUES', count)
      } else {
        this.searchLeague = false
        if(this.$store.getters.open_RBMarket && this.$store.getters.selectedSport.sprtId=='G98'){
          $.each(this.leagueList, function(sid, sdata){
            sdata.map(function(subArr) {
              return subArr.map(obj => obj.show=false)
            }) 
          })
        } else {
          this.leagueList.map(function(subArr) {
            return subArr.map(obj => obj.show=false)
          })
        }
        if(!this.$store.getters.open_RBMarket) {
          this.setStateList(this.leagueList, false)
        }

        this.$store.commit('TOTALLEAGUES', this.$store.getters.arr_leagueList.length)
      }

    },
    toggleLgSport() {
      this.showHide = (this.showHide) ? false : true;
    },
    toggleLeague() {  //toggle close league & get latest odds
      this.$store.commit('SPORT_LEAGUE_TOGGLE')
      let data={}
      data.token = token.arr_6
      EventBus.$emit('selectLeagueRefreshTable', data)
    },
    createGroupedArray(arr, chunkSize, isAllSport) {
      var i;

      if(isAllSport){ //by sports
        var groups = {}
        $.each(arr, function(id, data){
          var grpArr = []
          groups[id] = {}
          for (i=0; i<data.length; i+=chunkSize) {
            grpArr.push(data.slice(i, i + chunkSize));
          }
          groups[id] = grpArr
          // groups[id]['checked'] = false
        });
      } else {
        var groups = []
        if (arr.length < 30) {
          var insertToArraylength = 30 - arr.length
          for (i = 0; i < insertToArraylength; i++) {
            var defaultvalue = { id: null }
            arr.push(defaultvalue)
          }
        }
        if (this.$store.getters.selectedBettype.betTypId == '6') {
        arr.sort((a, b) => (a.capt > b.capt && !_.isUndefined(b.capt) && !_.isUndefined(a.capt)) ? 1 : -1)
        }else{
        arr.sort((a, b) => (a.f > b.f && !_.isUndefined(b.f) && !_.isUndefined(a.f)) ? 1 : -1)
        }
        const result = [];
        const map = new Map();
        for (const item of arr) {
          if(!map.has(item.id)){
              map.set(item.id, true);    // set any value to Map
              
              if (this.$store.getters.selectedBettype.betTypId == '6') {
                result.push({
                  c: item.c,
                  id: item.id,
                  capt: item.capt,
                });
              }else{
                result.push({
                  c: item.c,
                  f: item.f,
                  id: item.id,
                  lgecapt: item.lgecapt,
                  show: item.show,
                  sptid: item.sptid,
                  state: item.state,
                });
              }
          }
        }
        
        for (i = 0; i < result.length; i += chunkSize) {
          groups.push(result.slice(i, i + chunkSize));
        }
      }
    
      return groups;
    },
    filterLeague() {
      var data = {
        token: token.arr_6,
        callback: ((res) => {
          this.toggleLeague()
        }).bind(this)
      }
      this.$store.commit('SELECTED_PAGE', 1)

      if (this.selectedLeague.length != this.$store.getters.arr_leagueList.length) {
        this.$store.commit('SELECTED_LEAGUELIST', this.selectedLeague)
        this.$store.commit('COOKIE_LEAGUE', {
          selectedLeague: this.selectedLeague,
          remove: false,
        })

        data.selectedLeague = this.selectedLeague
      } else {
        this.$store.commit('COOKIE_LEAGUE', {
          remove: true,
        })
        this.$store.commit('SELECTED_LEAGUELIST', [])
      }
      this.$store.commit('SELECTEDLEAGUES', this.selectedLeague.length)
      this.$store.commit('TOTALLEAGUES', this.$store.getters.arr_leagueList.length)
      EventBus.$emit('refreshOdd', true)
      if (this.$store.getters.selectedBettype.betTypId == '6') { //if is outright
        this.$store.dispatch('getSportOutrightOdds', {
          'leagueList': this.selectedLeague,
          token: token.arr_6
        })
      } else {
        if(this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key){
          // let data={}
          // data.token = token.arr_6,
          this.toggleLeague() ;
          // EventBus.$emit('selectLeagueRefreshTable', data)
        }else{
          this.$store.dispatch('getSportOdds', data)
        }
      }
    },
    changeSelectAll() {
      this.selectAll = !this.selectAll
      if (this.selectAll == true) {
        this.selectedLeague = []
        _.forEach(this.$store.getters.arr_leagueList, (league) => {
          this.selectedLeague.push(league.id)
        });
        if(!this.$store.getters.open_RBMarket) {
          this.selectedLeagueState.map(obj => obj.checked=true)
        }
      } else {
        this.selectedLeague = []
        if(!this.$store.getters.open_RBMarket) {
          this.selectedLeagueState.map(obj => obj.checked=false)
        }
      }
    },
    checkLeague(sport, id) {
      if(this.selectedLeague.includes(id)){
        // var getIndex = _.findIndex(this.selectedLeague, {
        //   key: id,
        // });
        var key = _.findIndex(this.selectedLeague, (e) => {
                    return e == id;
                }, 0);
        this.selectedLeague.splice(key,1)
      } else {
        this.selectedLeague.push(id)
      }

      

      // this.selectedLeague.push(id)
      // this.selectedLeague.splice(getIndex,1)
      if(sport!=null){  //sport league
        if(this.$store.getters.open_RBMarket && this.$store.getters.selectedSport.sprtId=='G98') {
          this.changeSelectedLeague2(sport, id)
        } else {
          this.changeSelectedLeague3(sport)
        }
      }
    },
    changeSelectedLeague() {
      this.selectAll = this.selectedLeague.length == this.$store.getters.arr_leagueList.length ? true : false
      // if(this.selectedLeague.includes(id)){
      //   var key = _.findIndex(this.selectedLeague, (e) => {
      //               return e == id;
      //           }, 0);
      //   this.selectedLeague.splice(key,1)
      // }else{
      //   this.selectedLeague.push(id)
      // }
    },
    changeSelectedLeague2(sportObjKey, dataID) {
      this.selectAll = this.selectedLeague.length == this.$store.getters.arr_leagueList.length ? true : false
      var awa = this.selectedLeague
      var chkkk = false
      var vue = this
      var selLeaguesId = this.selectedLeague
      // var chked = this.selectedLeagueSport[key].checked
      $.each(vue.leagueList[sportObjKey], function(sid, sdata){
        $.each(sdata, function(id, coldata){
          if(selLeaguesId.includes(coldata.id)){
            // selLeaguesId.push(coldata.id)
            chkkk = true
          }
        });
      });
      this.selectedLeagueSport[sportObjKey].checked = chkkk
    },
    initleagueSelectionBox() {
      $('#leagueSelectionBox').css({
        'top': '27%',
        'left': '10%',
        // 'top':  this.$store.getters.sportLeagueWindowEvent.clientY + 50,
        // 'left': this.$store.getters.sportLeagueWindowEvent.clientX - 800
      }).fadeIn('slow');
      $('#leagueSelectionBox').draggable({
        // containment: '#contentsRight',
      })
    },
    highlightText(words, searchText) {
      function pregQuote(str) {
        return (str.trim() + '').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\/\:])/g, "\\$1")
      }
      if (this.searchText != "") {
        var iQuery = new RegExp(pregQuote(searchText), 'ig')
        return words.toString().replace(iQuery, function (matchedTxt, a, b) {
          return ('<span class=\'highlight\'>' + matchedTxt + '</span>');
        })
      }
      return words
    },
    setLeagueList(){
      if(this.$store.getters.open_RBMarket && this.$store.getters.selectedSport.sprtId=='G98'){
        //group league by sports for all sports (G98)
        var list = this.groupLGEBySports()
        var isSportAll = true
      } else { //normal
        var list = _.cloneDeep(this.$store.getters.arr_leagueList)
        var isSportAll = false

        if(!this.$store.getters.open_RBMarket && list && list.length > 0){
          this.setStateList(list, true)
        }
      }
      this.$store.commit('TOTALLEAGUES', this.$store.getters.arr_leagueList.length)
      var grouped = this.createGroupedArray(list, 3, isSportAll)
      
      // var grouped = list
      // return grouped
      this.leagueList = grouped
    },
    setStateList(list, initialSet) {
      let searchLeague = this.searchLeague
      let stateArr = []
      if(initialSet) {
        $.each(list, function(key, val){
          if(_.find(stateArr, { 'state': val.state })) {
            var sIndex = _.findIndex(stateArr, { 'state': val.state })
            if(!Object.keys(stateArr[sIndex]['leagues']).includes(val.id.toString())) {
              if((searchLeague && val.show) || !searchLeague) {
                stateArr[sIndex]['leagues'][val.id] = val
              }
            } else {
              stateArr[sIndex]['leagues'][val.id]['c'] += val.c
            }
          } else {
            var stateArrLen = stateArr.push({
              'state': val.state,
              'leagues': {},
              'checked': false,
            })
            if((searchLeague && val.show) || !searchLeague) {
              stateArr[stateArrLen-1]['leagues'][val.id] = val
            }
          }
        })
      } else {
        $.each(list, function(ridex, rArr){
          $.each(rArr, function(key, val){
            if(_.find(stateArr, { 'state': val.state })) {
              var sIndex = _.findIndex(stateArr, { 'state': val.state })
              if(!Object.keys(stateArr[sIndex]['leagues']).includes(val.id.toString())) {
                if((searchLeague && val.show) || !searchLeague) {
                  stateArr[sIndex]['leagues'][val.id] = val
                }
              } else {
                stateArr[sIndex]['leagues'][val.id]['c'] += val.c
              }
            } else {
              var stateArrLen = stateArr.push({
                'state': val.state,
                'leagues': {},
                'checked': false,
              })
              if((searchLeague && val.show) || !searchLeague) {
                stateArr[stateArrLen-1]['leagues'][val.id] = val
              }
            }
          })
        })
      }
      for (let index = (stateArr.length-1); index > -1; index--) {
        if(stateArr[index].leagues && (Object.keys(stateArr[index].leagues).length < 1 || stateArr[index].leagues.length < 1)) {
          stateArr.splice(index,1)
        }
      }
      this.selectedLeagueState = stateArr
    },
    selState(key){
      var vue = this
      var selLeaguesId = this.selectedLeague
      var chked = this.selectedLeagueState[key].checked
      if(vue.selectedLeagueState[key].leagues && Object.keys(vue.selectedLeagueState[key].leagues).length > 0) {
        $.each(vue.selectedLeagueState[key].leagues, function(lgeid, lgedt){
          if(!selLeaguesId.includes(lgedt.id) && chked){
            selLeaguesId.push(lgedt.id)
          }else if(!chked){
            var keyx = _.findIndex(selLeaguesId, (e) => {
                  return e == lgedt.id;
              }, 0);
            selLeaguesId.splice(keyx,1)
          }
        });
      }
    },
    changeSelectedLeague3(key) {
      this.selectAll = this.selectedLeague.length == this.$store.getters.arr_leagueList.length ? true : false
      var chkkk = false
      var vue = this
      var selLeaguesId = this.selectedLeague
      if(vue.selectedLeagueState[key].leagues && Object.keys(vue.selectedLeagueState[key].leagues).length > 0) {
        $.each(vue.selectedLeagueState[key].leagues, function(lgeid, lgedt){
          if(selLeaguesId.includes(lgedt.id)){
            chkkk = true
          }
        });
      }
      this.selectedLeagueState[key].checked = chkkk
    },
  },
  mounted() {
    // this.initleagueSelectionBox()
    EventBus.$emit('lgreloading', false)
    let Vue=this
    $(document).click(function (e) {
      // if ($(e.target).closest("#filter-content").length === 0) {
      //     Vue.toggleLeague();
      // }

      if(Vue.$store.getters.bool_leagueToggle && $(e.target).closest("#filter-content").length === 0){
        if($(e.target).closest(".select-btn.leagues-btn").length === 0){
          Vue.toggleLeague();
        }
      }
    });
    EventBus.$on("setLeagueList", (res) => {
      this.setLeagueList()
      $('#leagueSelection').niceScroll({  
        horizrailenabled: false,
        autohidemode: false, 
        cursorborder: "0px solid #fff", 
        zindex:48,
        railoffset: { left:10 },

      })
    });
  },
  beforeMount() {
    var selectedMarket = this.$store.getters.selectedMarket
    var selectedSport = this.$store.getters.selectedBettype.sprtId
    var selectedBettype = this.$store.getters.selectedBettype.betTypId
    if (this.$store.getters.isGameBannerSelected) {
      selectedBettype += 'gmBanner'
    }
    //check cookieleague valid or not
    if (this.cookieLeague) {
      if (this.cookieLeague[selectedMarket]) {
        if (this.cookieLeague[selectedMarket][selectedSport]) {
          if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype]) {
            if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length > 0) {
              this.$store.commit('SELECTED_LEAGUELIST', this.cookieLeague[selectedMarket][selectedSport][selectedBettype])
            } else {
              this.$store.commit('SELECTED_LEAGUELIST', [])
            }
          } else {
            this.$store.commit('SELECTED_LEAGUELIST', [])
          }
        } else {
          this.$store.commit('SELECTED_LEAGUELIST', [])
        }
      } else {
        this.$store.commit('SELECTED_LEAGUELIST', [])
      }
    }

    if (this.$store.getters.arr_selectedLeagueList.length == 0) {
      // this.selectAll = true
      // _.forEach(this.$store.getters.arr_leagueList, (league) => {
      //   this.selectedLeague.push(league.id)
      // });
    } else {
      this.selectedLeague = this.$store.getters.arr_selectedLeagueList
      this.selectAll = this.selectedLeague.length == this.$store.getters.arr_leagueList.length ? true : false
    }
  },
  beforeDestroy() {
    EventBus.$off("setLeagueList");
  },
  destroyed(){
    $('#leagueSelection').getNiceScroll().remove();
  },
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base/global";
// @import "~@/styles/components/forecast";
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/box/leagueSelectionBox.vue